import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const Coupon = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="69.296"
    height="69.296"
    viewBox="0 0 69.296 69.296"
  >
    <g transform="translate(-75.911 -32.071) rotate(-45)">
      <path
        d="M60,107.355H14v1a1,1,0,1,1-2,0v-1H2a2,2,0,0,0-2,2v8.8a1.461,1.461,0,0,0,.677,1.248A6.984,6.984,0,0,1,4,125.355,6.984,6.984,0,0,1,.677,131.3,1.462,1.462,0,0,0,0,132.552v8.8a2,2,0,0,0,2,2H12v-1a1,1,0,1,1,2,0v1H60a2,2,0,0,0,2-2v-32A2,2,0,0,0,60,107.355Zm-46,31a1,1,0,1,1-2,0v-2a1,1,0,1,1,2,0Zm0-6a1,1,0,0,1-2,0v-2a1,1,0,0,1,2,0Zm0-6a1,1,0,0,1-2,0v-2a1,1,0,0,1,2,0Zm0-6a1,1,0,0,1-2,0v-2a1,1,0,1,1,2,0Zm0-6a1,1,0,0,1-2,0v-2a1,1,0,0,1,2,0Z"
        fill="#ffc350"
      />
      <path
        d="M175.129,155.871h-42a1,1,0,0,1-1-1v-30a1,1,0,0,1,1-1h42a1,1,0,0,1,1,1v30A1,1,0,0,1,175.129,155.871Z"
        transform="translate(-116.129 -14.516)"
        fill="#ffd164"
      />
      <path
        d="M225.882,183.071l-5.183,3.254a1.5,1.5,0,0,1-2.247-1.632l1.493-5.935-4.7-3.924a1.5,1.5,0,0,1,.858-2.641l6.106-.414,2.281-5.679a1.5,1.5,0,0,1,2.777,0l2.281,5.679,6.106.414a1.5,1.5,0,0,1,.858,2.641l-4.7,3.924,1.493,5.935a1.5,1.5,0,0,1-2.247,1.632Z"
        transform="translate(-188.71 -50.805)"
        fill="#fff"
      />
      <path
        d="M232.662,232.127a16.986,16.986,0,0,1-14.484-10.055l-2.071.14a1.5,1.5,0,0,0-.858,2.641l4.7,3.924-1.493,5.935a1.5,1.5,0,0,0,2.247,1.632l5.183-3.254,5.183,3.254a1.5,1.5,0,0,0,2.247-1.632Z"
        transform="translate(-188.709 -100.825)"
        fill="#fff6d8"
      />
    </g>
  </Icon>
);

export default Coupon;



// WEBPACK FOOTER //
// ./src/components/Icons/Coupon.js